<div class="outside-container">
    <div class="container">
        <div class="title">
            <span class="icon">
                <i class="fa-2x fa-fw"
                   [ngClass]="userNavbarItem.icon"
                   aria-hidden="true">
                </i>
            </span>
            <span>
                {{'LAYOUT.MENU.' + userNavbarItem.id | translate}}
            </span>
        </div>
        <div class="container-content">
            <ng-content></ng-content>
        </div>
    </div>
</div>
